// src/components/ExpertCircleReferralCard.jsx
// Carte du tableau de bord expert : recommander un confrère au cercle des experts.
// Deux gestes : copier son lien de recommandation (/cercle-experts?ref=<id>) ou nous donner un nom
// (nous ne contactons le confrère qu'avec l'accord du membre). Aucune contrepartie, aucun engagement.
import React, { useEffect, useState } from "react";
import { supabase } from "@/lib/supabaseClient";
import { useAuth } from "@/context/AuthContext";
import { BRAND_NAME } from "@/config/brand";
import { track } from "@/lib/track";

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

export default function ExpertCircleReferralCard() {
  const { user } = useAuth() || {};
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [msg, setMsg] = useState(null);
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(0);

  const link = user?.id ? `${window.location.origin}/cercle-experts?ref=${user.id}` : "";

  useEffect(() => {
    if (!user?.id) return;
    supabase.from("expert_referrals").select("id", { count: "exact", head: true }).eq("referrer_id", user.id)
      .then(({ count }) => setSent(count || 0), () => {});
  }, [user?.id]);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(link);
      setMsg({ ok: true, text: "Lien copié. Transmettez-le à un confrère." });
      track("expert_referral_sent", { meta: { via: "link" } });
    } catch { setMsg({ ok: false, text: "Copie impossible : sélectionnez le lien à la main." }); }
  };

  const submit = async (e) => {
    e.preventDefault();
    if (!name.trim()) { setMsg({ ok: false, text: "Indiquez le nom du confrère." }); return; }
    if (email.trim() && !EMAIL_RE.test(email.trim())) { setMsg({ ok: false, text: "Email invalide." }); return; }
    setBusy(true); setMsg(null);
    const { error } = await supabase.rpc("recommend_expert", { p_name: name.trim(), p_email: email.trim() || null });
    setBusy(false);
    if (error) { setMsg({ ok: false, text: "La recommandation n'a pas pu être enregistrée." }); return; }
    setName(""); setEmail(""); setSent((n) => n + 1);
    setMsg({ ok: true, text: "Merci. Nous ne le contactons qu'avec votre accord : nous revenons vers vous." });
  };

  if (!user?.id) return null;
  return (
    <div style={{ background: "#fff", border: "1px solid #e5e3df", borderRadius: 4, padding: 20, marginBottom: 20 }}>
      <div style={{ fontSize: 11, letterSpacing: 2, textTransform: "uppercase", color: "#8a8378", marginBottom: 6 }}>Le cercle des experts</div>
      <h3 style={{ margin: "0 0 6px", fontSize: 18, fontWeight: 400 }}>Un confrère devrait-il rejoindre le cercle ?</h3>
      <p style={{ margin: "0 0 14px", fontSize: 14, color: "#4a453d", lineHeight: 1.55 }}>
        {BRAND_NAME} fonctionne par recommandation. Aucune contrepartie, aucun engagement : nous contactons le confrère avec votre accord.
      </p>
      <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginBottom: 12 }}>
        <input readOnly value={link} onFocus={(e) => e.target.select()} style={{ flex: 1, minWidth: 220, padding: "8px 10px", border: "1px solid #e5e3df", fontSize: 13 }} />
        <button type="button" onClick={copy} style={{ padding: "8px 14px", background: "#1a1a1a", color: "#fff", border: 0, cursor: "pointer", fontSize: 13 }}>Copier mon lien</button>
      </div>
      <form onSubmit={submit} style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
        <input value={name} onChange={(e) => setName(e.target.value)} placeholder="Nom du confrère" style={{ flex: 1, minWidth: 160, padding: "8px 10px", border: "1px solid #e5e3df", fontSize: 13 }} />
        <input value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email (facultatif)" style={{ flex: 1, minWidth: 160, padding: "8px 10px", border: "1px solid #e5e3df", fontSize: 13 }} />
        <button type="submit" disabled={busy} style={{ padding: "8px 14px", border: "1px solid #1a1a1a", background: "transparent", cursor: "pointer", fontSize: 13 }}>{busy ? "…" : "Recommander"}</button>
      </form>
      {msg && <p style={{ margin: "10px 0 0", fontSize: 13, color: msg.ok ? "#2c5f2d" : "#b91c1c" }}>{msg.text}</p>}
      {sent > 0 && <p style={{ margin: "8px 0 0", fontSize: 12, color: "#8a8378" }}>{sent} recommandation{sent > 1 ? "s" : ""} de votre part à ce jour.</p>}
    </div>
  );
}
